import React from "react";
import {Route,useRouteMatch} from "react-router-dom";
import {compose} from "recompose";
import {withUserContextProvider, withUserContextReady} from "../context/UserContext";
import MasterRoute from "../components/MasterRoute";
import MasterRoutes from "./MasterRoutes";
import AdvisersRoutes from "./AdvisersRoutes";

const UserRoutes = ()=>{
    const {path} = useRouteMatch();

    return (
        <>
            <Route path={`${path}`} component={AdvisersRoutes}/>
            <MasterRoute path={`${path}/m`} component={MasterRoutes}/>
        </>
    );
};

export default compose(
    withUserContextProvider,
    withUserContextReady,
)(UserRoutes);